<script setup>
import { inject } from 'vue';
import Card from '@/Components/Card/Card.vue';
import IconCheckCircle from '@/Components/Icons/IconCheckCircle.vue';
import IconCancel from '@/Components/Icons/IconCancel.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const result = inject('score');

const records = (() => {
  const nsRecordExists = !!result.records?.ns?.score;
  const mxRecordExists = !!result.records?.mx?.score;
  const aRecordExists = !!result.records?.a?.score;

  return [
    {
      title: t(
        'domain_score.partials.detailed_report.common.common_detail_card.ns_record'
      ),
      exists: nsRecordExists,
      message: nsRecordExists
        ? t(
            'domain_score.partials.detailed_report.common.common_detail_card.dns_provider',
            { provider: result.info.dns_provider }
          )
        : t(
            'domain_score.partials.detailed_report.common.common_detail_card.no_dns_presence'
          )
    },
    {
      title: t(
        'domain_score.partials.detailed_report.common.common_detail_card.mx_record'
      ),
      exists: mxRecordExists,
      message: mxRecordExists
        ? t(
            'domain_score.partials.detailed_report.common.common_detail_card.email_provider',
            { provider: result.records.mx.mail_provider }
          )
        : t(
            'domain_score.partials.detailed_report.common.common_detail_card.no_email_sending'
          )
    },
    {
      title: t(
        'domain_score.partials.detailed_report.common.common_detail_card.a_record'
      ),
      exists: aRecordExists,
      message: aRecordExists
        ? t(
            'domain_score.partials.detailed_report.common.common_detail_card.web_presence'
          )
        : t(
            'domain_score.partials.detailed_report.common.common_detail_card.no_web_presence'
          )
    }
  ];
})();
</script>

<template>
  <div>
    <div class="flex items-start gap-3">
      <h5 class="flex items-center gap-2 text-lg font-bold text-white">
        {{
          $t(
            'domain_score.partials.detailed_report.common.common_detail_card.common_records'
          )
        }}
      </h5>
    </div>
    <Card class="bg-white-opacity mt-4">
      <div
        v-for="(record, index) in records"
        :key="index"
        class="mb-2 flex flex-col items-start gap-2 text-sm last:mb-0 md:flex-row md:items-center md:gap-0"
      >
        <div class="font-bold md:w-1/6">{{ record.title }}</div>
        <div class="flex items-center">
          <div
            v-tooltip="
              record.exists
                ? $t(
                    'domain_score.partials.detailed_report.common.common_detail_card.record_found'
                  )
                : $t(
                    'domain_score.partials.detailed_report.common.common_detail_card.not_found'
                  )
            "
          >
            <IconCheckCircle
              v-if="record.exists"
              :size="20"
              class="text-success mr-2 shrink-0"
            />
            <IconCancel
              v-else
              :size="20"
              class="text-white-500 mr-2 shrink-0"
            />
          </div>
          {{ record.message }}
        </div>
      </div>
    </Card>
  </div>
</template>
